// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuex from 'vue'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill();

import App from './App'
import router from './router'
import store from './store'
import FastClick from 'fastclick' //使用 fastclick 解决移动端 300ms 点击延迟
import filters from './filters' //将全部过滤器放在 filters/index.js 中便于管理
import VueLazyLoad from 'vue-lazyload'
import i18n from './utils/i18n'
import VueClipboard from 'vue-clipboard2'
import Toast from './components/common/toast/toast'
import vuescroll from 'vuescroll/dist/vuescroll-slide';
import less from 'less'
/**
 * 注册全局过滤器
 */
filters(Vue)

Vue.config.productionTip = false;
/**
 * 移动设备上的浏览器默认会在用户点击屏幕大约延迟300毫秒后才会触发点击事件，这是为了检查用户是否在做双击
 * 源码报错修改：
 * FastClick.prototype.focus  中 targetElement.setSelectionRange(length, length); 添加try catch , 放置报错，导致聚焦无法弹起键盘
 * 并强制添加targetElement.focus();
 * 
 * 		layer.addEventListener('touchstart', this.onTouchStart, {passive:false});
    layer.addEventListener('touchmove', this.onTouchMove, {passive:false});
    layer.addEventListener('touchend', this.onTouchEnd, {passive:false});
        layer.addEventListener('touchcancel', this.onTouchCancel, {passive:false});
        
        添加 {passive:false} ， 否则 event.preventDefault(); 有的浏览器会报错
 * 
 */
FastClick.attach(document.body);
Vue.use(vuescroll);

Vue.use(less);


Vue.use(VueClipboard);

Vue.use(Toast)

Vue.use(VueLazyLoad);
/**
 * 技巧 同时 use 多个插件 被依赖的插件应放在偏后方
 */
Vue.use(VueAxios, axios, vuex);
/**
 * 注册全局过滤器
 */
filters(Vue)

// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

/**
 * 移动设备上的浏览器默认会在用户点击屏幕大约延迟300毫秒后才会触发点击事件，这是为了检查用户是否在做双击
 * 源码报错修改：
 * FastClick.prototype.focus  中 targetElement.setSelectionRange(length, length); 添加try catch , 放置报错，导致聚焦无法弹起键盘
 * 并强制添加targetElement.focus();
 * 
 * 		layer.addEventListener('touchstart', this.onTouchStart, {passive:false});
    layer.addEventListener('touchmove', this.onTouchMove, {passive:false});
    layer.addEventListener('touchend', this.onTouchEnd, {passive:false});
        layer.addEventListener('touchcancel', this.onTouchCancel, {passive:false});
        
        添加 {passive:false} ， 否则 event.preventDefault(); 有的浏览器会报错
 * 
 */
FastClick.attach(document.body);

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js